export interface ReMintComponentsProps {
  reMint: () => void;
  reMinting: boolean;
  currentScore: number;
  expirationDate: number | null;
  newScore?: number;
}

export enum ReMintVariant {
  BaseReMint,
  ReMintWithExpired,
  ReMintWithExpiredAndUpdate,
  ReMintWithUpcomingExpiry,
  ReMintWithUpcomingExpiryAndUpdated,
}
